// extracted by mini-css-extract-plugin
export var badge = "style-module--badge--7babd";
export var cardContainer = "style-module--cardContainer--24f3a";
export var figure = "style-module--figure--b411b";
export var hover = "style-module--hover--c27af";
export var imageWrapper = "style-module--imageWrapper--1f557";
export var innerContainer = "style-module--innerContainer--75aa8";
export var innerGrid = "style-module--innerGrid--14eda";
export var link = "style-module--link--87472";
export var smallTitle = "style-module--smallTitle--6bd01";
export var summaryContainer = "style-module--summaryContainer--eed9f";